// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#bioSigModal .modal-body {
  padding-left: 2rem;
  padding-right: 2rem;
  padding-bottom: 1rem;
  width: 750px;
}

#bioSigModal .bioSigBtn {
  margin-top: 1rem;
  float: right;
}

#bioSigModal .modal-content {
  height: 100%;
}

#bioSigModal .modal-dialog {
  width: 750px;
  margin-top: 50px;
}

#bioSigModal .nmlsEmail {
  padding-top: 10px;
}

#bioSigModal .modal-title {
  padding-left: 15px;
}

#bioSigModal input {
  border-radius: 0;
  border: 1px solid black;
  width: 100%;
}

#bioSigModal .bioSigFrame {
  height: 700px;
  width: 720px;
}

#bioSigModal .bioSigHelp {
  margin-left: 87%;
  position: absolute;
  right: 55px;
  text-align: center;
  top: 10px;
}

#bioSigModal .modal-header {
  padding-bottom: 25px;
}

.bioSigModal .alert-danger {
  background-color: #f2dede;
  border-color: #ebccd1;
}

.bioSigModal .alert {
  padding: 15px;
  border: 1px solid transparent;
  border-radius: 4px;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/users/BioSigModal.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;AACpB","sourcesContent":["#bioSigModal .modal-body {\n  padding-left: 2rem;\n  padding-right: 2rem;\n  padding-bottom: 1rem;\n  width: 750px;\n}\n\n#bioSigModal .bioSigBtn {\n  margin-top: 1rem;\n  float: right;\n}\n\n#bioSigModal .modal-content {\n  height: 100%;\n}\n\n#bioSigModal .modal-dialog {\n  width: 750px;\n  margin-top: 50px;\n}\n\n#bioSigModal .nmlsEmail {\n  padding-top: 10px;\n}\n\n#bioSigModal .modal-title {\n  padding-left: 15px;\n}\n\n#bioSigModal input {\n  border-radius: 0;\n  border: 1px solid black;\n  width: 100%;\n}\n\n#bioSigModal .bioSigFrame {\n  height: 700px;\n  width: 720px;\n}\n\n#bioSigModal .bioSigHelp {\n  margin-left: 87%;\n  position: absolute;\n  right: 55px;\n  text-align: center;\n  top: 10px;\n}\n\n#bioSigModal .modal-header {\n  padding-bottom: 25px;\n}\n\n.bioSigModal .alert-danger {\n  background-color: #f2dede;\n  border-color: #ebccd1;\n}\n\n.bioSigModal .alert {\n  padding: 15px;\n  border: 1px solid transparent;\n  border-radius: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
